import { ContactInformationType } from '@iota/iota-management-portal-v4-client';

export const ContactInformationTypes: string[] = [
    ContactInformationType.PRIVATE,
    ContactInformationType.WORKPLACE,
    ContactInformationType.OTHER
];

export const ContactInformationTypeDescription = new Map([
    ['PRIVATE', $localize`private`],
    ['WORKPLACE', $localize`work`],
    ['OTHER', $localize`Others`]
]);
